import { useParams, Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { mcpCall } from '../lib/mcp';
import { useMcpTools } from '../lib/useMcpTools';
import { money, pct } from '../lib/format';
import './Reps.css';

interface Rep {
  id: number;
  public_id: string;
  email: string;
  display_name: string;
  territory: string | null;
  commission_rate: number | string | null;
  status: string;
  firebase_uid: string | null;
  created_at: string;
  // Lifetime earned commission (excluding voided), returned by getRep as a numeric STRING;
  // COALESCEd to 0 server-side. Mirrors the Reps list's Total Commission column.
  commission_total_usd?: number | string | null;
}

export function RepDetail() {
  const { id } = useParams();
  const { can } = useMcpTools();
  const canGet = can('getRep');

  // getRep returns the row directly (or null) — not wrapped.
  const { data, isLoading, error } = useQuery({
    queryKey: ['mcp', 'getRep', id],
    queryFn: () => mcpCall<Rep | null>('getRep', { id: Number(id) }),
    enabled: canGet && !!id,
  });
  const rep = data ?? null;

  return (
    <section className="records">
      <header className="records__head">
        <div className="records__head-text">
          <Link to="/reps" className="rep-detail__back">← Reps</Link>
          <h1 className="records__title">{rep?.display_name ?? `Rep #${id}`}</h1>
        </div>
      </header>

      <div className="records__panel rep-detail__panel">
        {!canGet && <p className="rep-detail__note">Rep detail isn’t available yet (pending the MCP redeploy).</p>}
        {canGet && isLoading && <p className="rep-detail__note">Loading…</p>}
        {canGet && error && <p className="rep-detail__note">Couldn’t load this rep.</p>}
        {canGet && !isLoading && !error && !rep && <p className="rep-detail__note">No record found for this rep.</p>}
        {rep && (
          <dl className="rep-detail">
            <div className="rep-detail__row"><dt>Email</dt><dd>{rep.email || '—'}</dd></div>
            <div className="rep-detail__row"><dt>Territory</dt><dd>{rep.territory || '—'}</dd></div>
            <div className="rep-detail__row"><dt>Commission rate</dt><dd>{pct(rep.commission_rate)}</dd></div>
            <div className="rep-detail__row"><dt>Total commission</dt><dd>{money(rep.commission_total_usd)}</dd></div>
            <div className="rep-detail__row"><dt>Status</dt><dd>{rep.status || '—'}</dd></div>
            <div className="rep-detail__row"><dt>Public ID</dt><dd>{rep.public_id || '—'}</dd></div>
          </dl>
        )}
      </div>
    </section>
  );
}
